export const PROGRAM_TILES_VIEW = 'tiles';
export const PROGRAM_LINES_VIEW = 'lines';
export const PROGRAM_GRID_VIEW = 'grid';

export const PROGRAM_VIEWS = [
    {
        value: PROGRAM_TILES_VIEW,
        show: true,
    },
    {
        value: PROGRAM_LINES_VIEW,
        show: false,
    },
    {
        value: PROGRAM_GRID_VIEW,
        show: false,
    },
];

export const PROGRAM_FILTERS_TAB = 'tabs';
export const PROGRAM_FILTERS_PAGE = 'page';
export const PROGRAM_FILTERS_HIDE = 'hide';

export const PROGRAM_FILTERS_VIEWS = {
    [PROGRAM_FILTERS_TAB]: PROGRAM_FILTERS_TAB,
    [PROGRAM_FILTERS_PAGE]: PROGRAM_FILTERS_PAGE,
};

export const PROGRAM_TIME_INTERVALS = [0, 5, 15, 30, 60];

export const PROGRAM_INITIAL_MODEL = {
    backgroundUrl: '',
    backgroundFixed: true,
    daysView: PROGRAM_FILTERS_TAB,
    hallsView: PROGRAM_FILTERS_TAB,
    intervals: 0,
    scheduleViews: PROGRAM_VIEWS,
    showAddToCalendar: true,
    showDescription: true,
    showModals: true,
    showPhotos: true,
    showTitle: true,
    titleEn: 'Program',
    titleRu: 'Программа',
    showSubstrate: true,
    gridCardHeightSize: '3px',
    showStatuses: true,
    showFormats: true,
};
